import axios from 'axios';
import { Container, Singleton } from 'typescript-ioc/es5';
import { action } from 'mobx';
import { APP_BASE_ROUTE, APP_PREAUTH_ROUTE, REF_QUERY_PARAM, AUTH_REDIRECT_PARAM } from '../constants';
import { UserDto } from '../dtos/user';
import { IApiResponseSuccess } from '../models/api-response-success';
import { AppState } from '../stores/app';
import { AppService } from './app';
import { sendGAEvent } from '../components/ga-helper/ga-helper';
import { axiosFetch } from '../config/axios-setup';
import aqe from '@pushly/aqe';
import { RefQueryValue } from '../enums/ref-query-value';
import { shouldUseLegacyAuthHeader } from '../_utils/utils';
import { PushlyCookie } from '../enums/pushly-cookie.enum';

@Singleton
export class AuthService {
    private appState: AppState;
    private appService: AppService;

    public constructor() {
        this.appState = Container.get(AppState);
        this.appService = Container.get(AppService);
    }

    @action.bound
    public async login(email: string, password: string) {
        const response = await axios.post<IApiResponseSuccess<UserDto> & { token: string }>(`${aqe.defaults.publicApiDomain}/auth/login`, { email, password }, {
            bypassGlobalErrorHandlers: true,
        } as any);
        const responseData = response.data;

        if (shouldUseLegacyAuthHeader()) {
            window.localStorage.setItem(PushlyCookie.PLATFORM_COOKIE, responseData.token);
        }

        this.appState.currentUser = UserDto.fromApiResponse(responseData.data);

        await this.appState.fetchUserDependencies();

        this.appState.isAuthenticated = true;
        sendGAEvent('set_current_user', {}, this.appState);
        this.appService.reset404State();
    }

    @action.bound
    public async logout(
        expired: boolean = false
    ) {
        this.appService.setAppLoading();

        try {
            if (!expired) {
                await axiosFetch('post', {
                    url: `${aqe.defaults.publicApiDomain}/auth/logout`
                }, 'logout');
            }
        } catch {}

        this.appService.stopFetchingPlatformMessages();

        if (shouldUseLegacyAuthHeader()) {
            window.localStorage.removeItem(PushlyCookie.PLATFORM_COOKIE);
        }

        this.appState.currentUser = undefined;
        this.appState.currentDomainJsonData = undefined;
        this.appState.isAuthenticated = false;
        this.appState.abilityStore.flush();

        this.appService.reset404State();

        if (expired) {
            location.href = APP_PREAUTH_ROUTE
                + `?${REF_QUERY_PARAM}=${RefQueryValue.EXPIRED_SESSION}`
                + `&${AUTH_REDIRECT_PARAM}=${location.pathname}`;
        } else {
            location.href = APP_BASE_ROUTE;
        }
    }
}
